module.exports = __webpack_public_path__ + "img/ios_tutorial04.24a338af.jpg";